import store from "../../../../../store";
import { commonInputPropField } from "../license/request-license.condition";
import { has } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    // let myRoleName = []
    // store.state.resource.auth.info?.roles.forEach(userRole => {
    //     myRoleName.push(userRole.refRole.name)
    // })

    // return {
    //     canEdit: ({ props, record }) => {
    //         let result = false;
    //         const { menuContext } = props;
    //         if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
    //         if (record.createBy === store.state.resource.auth.info.user?.username) {
    //             if ([undefined, "draft", "waitModify"].includes(record.refStatus?.key)) {
    //                 result = true || result;
    //             }
    //         }
    //         if (has({ menuContext, key: "forReviewRequest" })) {
    //             if (["waitAcceptRequest"].includes(record.refStatus?.key)) {
    //                 result = true || result;
    //             }
    //         }
    //         if (has({ menuContext, key: "forAuthorized" })) {
    //             if (["waitApprove"].includes(record.refStatus?.key)) {
    //                 result = true || result;
    //             }
    //         }
    //         return result;
    //     },
    //     canArchive: ({ props, record }) => {
    //         let result = false;
    //         const { menuContext } = props;
    //         if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
    //         if (["draft"].includes(record.refStatus?.key)) {
    //             result = true || result;
    //         }
    //         return result;
    //     },
    //     canDelete: ({ props, record }) => {
    //         let result = false;
    //         const { menuContext } = props;
    //         if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
    //         if (["draft"].includes(record.refStatus?.key)) {
    //             result = true || result;
    //         }
    //         return result;
    //     },
    //     canWaitFisheryOfficer: ({ props, record }) => {
    //         let result = false;
    //         const { menuContext } = props;
    //         if (has({ menuContext, key: "forRequest" })) {
    //             if (record.createBy === store.state.resource.auth.info?.user?.username && !record.isOfficerCreate) {
    //                 if (["draft", "waitModify"].includes(record.refStatus?.key)) {
    //                     result = true || result;
    //                 }
    //             }
    //         }
    //         return result;
    //     },
    //     canConfirmResult: ({ props, record }) => {
    //         let result = false;
    //         const { menuContext } = props;
    //         // const userInfo = store.state.resource.auth.info?.user;
    //         if (record.isActive === false) return false;

    //         if (has({ menuContext, key: "forReviewRequest" })) {
    //             if (["waitAcceptRequest"].includes(record.refStatus?.key)) {
    //                 result = true || result;
    //             }
    //         }
    //         if (has({ menuContext, key: "forAuthorized" })) {
    //             if (["waitApprove"].includes(record.refStatus?.key)) {
    //                 result = true || result;
    //             }
    //         }

    //         return result;
    //     },
    // }
}

export const createConditionForm = () => {
    let myRoleName = []
    store.state.resource.auth.info?.roles.forEach(userRole => {
        myRoleName.push(userRole.refRole.name)
    })
    return [
        {
            check: ({ field }) => {
                return [
                    "refStatus",
                    "changeStatusRemark",
                ].includes(field?.key);
            },
            visibleField: ({ data }) => {
                return ["EDIT_LICENSE_STATUS"].includes(data.roleEdit);
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refReceiveDept",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
                disabledRequestTypes: [],
            }),
        },
        // Always hidden input field because bellow field show only LicenseForm.vue
        {
            check: ({ field }) => {
                return [
                    "licenseCode",
                    "refRequesterLifeStatus"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        // Always disable input field
        {
            check: ({ field }) => {
                return [
                    "requestCode",
                    "requestDate",
                    "requesterIdCard",
                    "refRequesterNationality",
                    "refVesselRequest.name",
                    "refVesselRequest.tgross",
                    "refVesselRequest.tnange",
                    "refVesselRequest.vesselType",
                    "refVesselRequest.useType",
                    "refVesselRequest.licenseIssueDate",
                    "refVesselRequest.licenseExpireDate",
                    "refVesselRequest.registrationDate",
                    "refVesselRequest.lbp",
                    "refVesselRequest.loa",
                    "refVesselRequest.deep",
                    "refVesselRequest.breadth",
                    "refVesselRequest.licenseNumber",
                    "refOriginal.refVesselRequest.code",
                    "totalForeignWorkers",
                    "foreignMaleWorkers",
                    "foreignFemaleWorkers",
                    "totalThaiWorkers",
                    "thaiMaleWorkers",
                    "thaiFemaleWorkers"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        ///กรณีเคลื่อนย้ายประมง
        {
            check: ({ field }) => {
                return [
                    "refFishingArea",
                ].includes(field?.key);
            },
            // inputPropField: ({ props, modelRef, initialModel }) => {
            //     const { viewOnly } = props;
            //     const common = commonInputPropField({
            //         disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
            //         disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            //     })({ modelRef, initialModel });
            //     if (common.disabled !== true) {
            //         common.disabled = viewOnly || !["moveAshore"].includes(modelRef.refChangeLicenseObjective?.key);
            //     }
            //     return common;
            // }
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refChangeFishingAreaRemark",
                    "movingShipMode"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !["moveAshore"].includes(modelRef.refChangeLicenseObjective?.key);
                }
                return common;
            },
            visibleField: ({ modelRef }) => {
                return ["moveAshore"].includes(modelRef.refChangeLicenseObjective?.key);
            }
        },
        {
            check: ({ field }) => {
                return [
                    "otherRemark"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            },
            visibleField: ({ modelRef }) => {
                return (["moveAshore"].includes(modelRef.refChangeLicenseObjective?.key) && ["99"].includes(modelRef.refChangeFishingAreaRemark?.key)) || (["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key) && ["4", "2"].includes(modelRef.refReplaceShipRemark?.key)) ;
            },
        },

        // กรณีทดแทนเรือ
        {
            check: ({ field }) => {
                return [
                    "reasonReplace",
                    "dockReplaceShip",
                    "refReplaceShipRemark"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key);
                }
                return common;
            },
            visibleField: ({ modelRef }) => {
                return ["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key);
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return { disabled: modelRef.id != null};
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refChangeLicenseObjective",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return { disabled: modelRef.id != null || modelRef.refOriginal == null };
            }
        },
        // {
        //     check: ({ field }) => {
        //         return [
        //             "refChangeLicenseObjective",
        //         ].includes(field?.key);
        //     },
        //     inputPropField: ({ props, modelRef, initialModel }) => {
        //         const { viewOnly } = props;
        //         const common = commonInputPropField({
        //             disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
        //             disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
        //         })({ modelRef, initialModel });
        //         if (common.disabled !== true) {
        //             common.disabled = viewOnly || !modelRef.refOriginal;
        //         }
        //         return common;
        //     }
        // },
        {
            check: ({ field }) => {
                return [
                    "refVesselRequest.code",
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !["replaceBoat", "editRegistration"].includes(modelRef.refChangeLicenseObjective?.key);
                }
                return common;
            }
        },
        // Control การเห็น Field ตามประเภทบุคคล หรือ นิติบุคคล
        {
            check: ({ field }) => {
                return [
                    "refRequesterTitle",
                    "requesterFirstName",
                    "requesterFirstNameSpace",
                    "requesterLastName",
                    "refRequesterNationality",
                    "requesterAge",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refRequesterPersonType?.key == '2';
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refRequesterTitle",
                    "refOriginal.requesterFirstNameSpace",
                    "refOriginal.requesterFirstName",
                    "refOriginal.requesterLastName",
                    "refOriginal.refRequesterNationality",
                    "refOriginal.requesterAge",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOriginal?.refRequesterPersonType?.key == '2';
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refOwnerTitle",
                    "refOriginal.ownerFirstNameSpace",
                    "refOriginal.ownerFirstName",
                    "refOriginal.ownerLastName",
                    "refOriginal.refOwnerNationality",
                    "refOriginal.ownerAge",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOriginal?.refRequesterPersonType?.key == '2';
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refFishingArea",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return (modelRef.refOriginal && ["moveAshore"].includes(modelRef.refChangeLicenseObjective?.key)) || false;
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refRequesterCompanyType",
                    "requesterName",
                    "requesterShareholdingTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refRequesterPersonType?.key == '1';
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refRequesterCompanyType",
                    "refOriginal.requesterName",
                    "refOriginal.requesterShareholdingTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOriginal?.refRequesterPersonType?.key == '1';
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refOwnerCompanyType",
                    "refOriginal.ownerName",
                    "refOriginal.ownerShareholdingTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOriginal?.refOwnerPersonType?.key == '1';
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        // Disable when user is not officer
        {
            check: ({ field }) => {
                return [
                    "refRequesterPersonType",
                    "requesterName",
                    "refRequesterCompanyType",
                    "refRequesterTitle",
                    "requesterFirstName",
                    "requesterFirstNameSpace",
                    "requesterLastName",
                    "requesterShareholdingTh"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel",  "appeal"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (modelRef.refChangeLicenseObjective?.key == "editRegistration" && common.disabled !== true) {
                        common.disabled = viewOnly ;
                    } else {
                        common.disabled = true ;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refRequesterPersonType",
                    "refOriginal.requesterIdCard",
                    "refOriginal.requesterMobile",
                    "refOriginal.requesterEmail",
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refOriginal.refOwnerPersonType",
                    "refOriginal.ownerIdCard",
                    "refOriginal.ownerMobile",
                    "refOriginal.ownerEmail",
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        // Address
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addresses\\.[^\\.]+\\.(refAddressType|fax|latitude|longitude|email|tel)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refOriginal.addresses\\.[^\\.]+\\.(refAddressType|fax|latitude|longitude|email|tel)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refOriginal.addressOwners\\.[^\\.]+\\.(refAddressType|fax|latitude|longitude|email|tel)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly ;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly ;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refOriginal.addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refOriginal.addressOwners\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addresses\\.[^\\.]+\\.(refAmphur)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly || !modelRef.addresses[0].refProvince;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "requesterMobile",
                    "requesterEmail",
                    "requesterAge",
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                const testReg = new RegExp(
                    `^attachments\\.[^\\.]+\\.(isVerify||isReject)$`,
                    "g"
                ).test(field?.key);
                return testReg;
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (["waitAcceptRequest", "waitModify", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [undefined, "draft",  "waitRDAudit", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            })
        },
          // Always disable input field
        {
            check: ({ field }) => {
                const testReg = new RegExp(
                    `^refVesselRequest\\.(attachmentVesselIdentities|attachmentPositionVesselIdentities|attachmentHeadVessels|attachmentFullVessels)`,
                    "g"
                ).test(field?.key);
                return testReg;
            },
            visibleField: ({ modelRef }) => {
                return ["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key);
            },
        },
        {
            check: ({ field }) => {
                const testReg = new RegExp(
                    `^refOriginal.refVesselRequest\\.(attachmentVesselIdentities|attachmentPositionVesselIdentities|attachmentHeadVessels|attachmentFullVessels)\\.[^\\.]+\\.(size)$`,
                    "g"
                ).test(field?.key);
                return testReg;
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                const testReg = new RegExp(
                    `^refOriginal.refVesselRequest\\.(attachmentVesselIdentities|attachmentPositionVesselIdentities|attachmentHeadVessels|attachmentFullVessels)`,
                    "g"
                ).test(field?.key);
                return testReg;
            },
            visibleField: ({ modelRef }) => {
                return ["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key);
            },
        },
        // Case: Can view only officer create
        {
            check: ({ field }) => {
                return ["isAttorneySpace", "isAttorney"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            checkboxField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refAttorneyTitle",
                    "attorneyFirstName",
                    "attorneyFirstNameSpace",
                    "attorneyLastName",
                    "attorneyIdCard",
                    "attorneyPhoneNumber",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficerCreate;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (modelRef.isOfficerCreate) {
                    if (common.disabled !== true) {
                        common.disabled = viewOnly || !modelRef.isAttorney;
                    }
                } else if(!modelRef.isOfficerCreate) {
                    common.disabled = true;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "isThaiWorkers",
                    "isForeignWorkers"
                ].includes(field?.key);
            },
            checkboxField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"],
                disabledRequestTypes: ["renewLicense", "changeLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            })
        },
        // Control:
        //     |-> case1 : role and department or parent of user
        //     |-> case2 :
        {
            check: ({ field }) => {
                return ["forReviewRequest"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (!["draft", undefined].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["draft",  "waitModify", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", ""],
                disabledRequestTypes: []
            }),
        },
        {
            check: ({ field }) => {
                return [
                    "expireDateToEdit",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refFisheriesOfficerStatus?.key === "disagree" ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["waitModify", "waitLawyerAudit", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["requestLicense", "renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || modelRef.refFisheriesOfficerStatus?.key !== "disagree";
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refFisheriesOfficerStatus",
                    "attachmentReviewRequests"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "fisheriesOfficerRemark",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !modelRef.isFisheriesOfficerRemark;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "fisheriesOfficerRemark2",
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitLawyerAudit", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !modelRef.isFisheriesOfficerRemark2;
                }
                return common;
            }
        },
        // isCancel ขอยกเลิก ของชาวประมง
        {
            check: ({ field }) => {
                return [
                    "isCancelRequest",
                ].includes(field?.key);
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (![undefined, "draft"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const userInfo = store.state.resource.auth.info?.user;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft", "waitDofCenterAudit","waitApprove", "approve", "notApprove", "appeal", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = (userInfo.username !== modelRef.createBy);
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "isCancelRequest",
                    "cancelRequestRemark",
                    "attachmentCancelRequests",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [undefined, "draft", "waitDofCenterAudit","waitApprove", "approve", "notApprove", "appeal", "cancel"],
                disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "cancelRequestRemark",
                    "attachmentCancelRequests",
                ].includes(field?.key);
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (modelRef.isCancelRequest) {
                    visible = true || visible;
                }
                return visible;
            },
        },
         /* For RD */
         {
            check: ({ field }) => {
                return [
                    "forRDAuditor",
                    "refRdStatus",
                    "rdRemark",
                    "attachmentRDs"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitLawyerAudit"].includes(modelRef.refStatus?.key)) {
                    visible = ( true || visible ) && ["tool", "moveAshore"].includes(modelRef.refChangeLicenseObjective?.key);
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
         /* For Lawyer */
         {
            check: ({ field }) => {
                return [
                    "forLawyerAuditor",
                    "refLawyerStatus",
                    "lawyerRemark",
                    "attachmentLawyers"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit"].includes(modelRef.refStatus?.key)) {
                    visible = ( true || visible ) && ["replaceBoat"].includes(modelRef.refChangeLicenseObjective?.key);
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        {
            check: ({ field }) => {
                return [
                    "inspectionApplicant",
                    "inspectionVessel"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Argue Lawyer */
        {
            check: ({ field }) => {
                return [
                    "argueLawyer",
                    "refArgueLawyerStatus",
                    "argueLawyerRemark",
                    "attachmentArgueLawyers"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (
                    ![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit"].includes(modelRef.refStatus?.key)
                    && modelRef.isHaveArgueLawyer
                ) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitDofCenterAudit", "waitRDAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Dof Center */
        {
            check: ({ field }) => {
                return [
                    "dofCenterConsider",
                    "refDofCenterStatus",
                    "dofCenterRemark",
                    "attachmentDofCenters"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer",  "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Director */
        {
            check: ({ field }) => {
                return ["directorConsider"].includes(field?.key);
            },
            visibleField: ({  modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify", "waitRDAudit", "waitLawyerAudit", "waitDofCenterAudit"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refDirectorStatus",
                    "directorRemark",
                    "attachmentDirectors"
                ].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel, props }) => {
                const { viewOnly, menuContext } = props;
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"],
                })({ modelRef, initialModel });
                if (!has({ menuContext, key: "forAuthorized"})) {
                    common.disabled = true;
                }
                else if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            }
        },
        /* For Appeal สำหรับผู้ยื่นคำขอและสิทธิ์อธิบดี */
        {
            check: ({ field }) => {
                return [
                    "appealRequestDetail",
                    "refAppealRequestStatus",
                    "appealRequestRemark",
                    "attachmentAppealRequests",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (modelRef?.refStatus?.key == "notApprove" || modelRef.isHaveAppealedRequest) {
                    visible = true || visible;
                }
                return visible ;
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["draft", "waitModify", "waitAcceptRequest", "waitLawyerAudit",  "waitDofCenterAudit", "waitApprove", "approve", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                if (!modelRef.isCanAppealRequest) {
                    common.disabled = true;
                } else if (common.disabled !== true && modelRef.isCanAppealRequest) {
                    common.disabled = false;
                }
                common.disabled = common.disabled || modelRef.createBy !== store.state.resource.auth.info.user?.username
                return common;
            }
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("licenseRequestInspections.") &&
                    (field?.key?.endsWith(".isResult"))
                );
            },
            visibleField: ({ modelRef }) => {
                let visible = false;
                if (![undefined, "draft", "waitAcceptRequest", "waitModify"].includes(modelRef.refStatus?.key)) {
                    visible = true || visible;
                }
                return visible ;
            },
            checkedProp: ({ props, items, item, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                let onUpdateCheck = undefined;
                const attribute = item.refInspectionTopic?.attribute;
                let otherCheckInGroup = false;
                if (attribute?.checkGroup) {
                    otherCheckInGroup = items.find(d =>
                        d.refInspectionTopic.id !== item.refInspectionTopic.id &&
                        d.refInspectionTopic.attribute?.checkGroup === attribute?.checkGroup &&
                        d.isResult
                    )
                }

                let parentIsChecked = true
                if (item?.refParent) {
                    parentIsChecked = items.find(d =>
                        d.id === item?.refParent?.id &&
                        d.isResult
                    )
                }

                enabled = ( item.refInspectionTopic.attribute?.canCheck &&
                    !viewOnly && !otherCheckInGroup && !!parentIsChecked
                ) || enabled;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft", "waitModify", "waitAcceptRequest", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
                })({ modelRef, initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly || !enabled;
                }

                onUpdateCheck = checked => {
                    item.isSave = true;
                    item.isResult = checked;
                    if (!checked) {
                        let childrenInspection = items.filter(d => {
                            return item.children?.map(d => d.id).includes(d?.id)
                        })
                        childrenInspection.forEach(d => {
                            d.isSave = true;
                            d.isResult = false
                        })
                    }
                }
                return { ...common, "onUpdate:checked": onUpdateCheck };
            },
        },
        {
            check: ({ componentKey }) => {
                return ["AttachmentInlineList"].includes(componentKey);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "waitModify"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                return { canCreate, canDelete };
            }
        }
    ]
};

